import { Editor, Node, Transforms } from 'slate';
import { getListsInRange } from "../lib/index.js";

/**
 * Sets "type" of all "list" nodes in the current selection.
 */
export function setListType(editor, listType) {
  if (!editor.selection) {
    return;
  }

  var lists = getListsInRange(editor, editor.selection);
  var refs = lists.map(_ref => {
    var [_, path] = _ref;
    return Editor.pathRef(editor, path);
  });
  refs.forEach(ref => {
    var path = ref.current;
    var node = path ? Node.get(editor, path) : null;

    if (node && path) {
      Transforms.setNodes(editor, editor.createListNode(listType, node), {
        at: path
      });
    }

    ref.unref();
  });
}